import EntityStore from 'es/app/store/EntityStore';
import { computed, makeObservable, observable } from 'mobx';
import { ReportDefinition, ReportTypeConfiguration } from 'es/app/__generated__/global';

export default class ReportStore extends EntityStore<ReportDefinition> {
    constructor() {
        super();
        makeObservable(this, {
            reports: computed,
            reportTypes: observable,
        });
    }

    public get reports(): ReportDefinition[] {
        return this.entities;
    }

    public reportTypes: ReportTypeConfiguration[] = [];
}
